import Icon, { IconType } from "@edaz/edazkit/Icon";
import Button from "@edaz/edazkit/Button";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import React from "react";
import { observer } from "mobx-react-lite";
import AccountingTemplatesViewModel from "viewModels/finance/accountingTemplates/accountingTemplatesViewModel";

const AccountingTemplatesView: ViewComponent<AccountingTemplatesViewModel> = observer(({ vm }) => {
  return (
    <>
      <h3>{vm.name}</h3>
      <div className="border rounded py-5 py-md-6 py-lg-8 text-center">
        <Icon icon={IconType.Excel} width={64} height={64} />
        <h5 className="mb-2 mt-4">{vm.translate("name")}</h5>
        <p className="mb-5">{vm.translate("description")}</p>
        <Button
          iconLeft={vm.busyWatcher.isBusy ? IconType.Spinner : IconType.Download}
          onClick={vm.onDownloadClick}
          className="rounded"
          disabled={vm.busyWatcher.isBusy}>
          {vm.translate("downloadFile")}
        </Button>
      </div>
    </>
  );
});

registerView(AccountingTemplatesView, AccountingTemplatesViewModel);
